const localStorageUtils = {
  setWithExpire: function (key, value, expireTime) {
    localStorage.setItem(key, value)
    if (expireTime) {
      localStorage.setItem(key + '__et', expireTime)
    }
  },
  set: function (key, value, seconds) {
    localStorage.setItem(key, value)
    if (typeof seconds === 'number' && seconds > 0) {
      var expireTime = (new Date()).getTime() + seconds * 1000
      localStorage.setItem(key + '__et', expireTime)
    }
  },
  get: function (key) {
    var value = localStorage.getItem(key)
    if (!value) {
      return null
    }
    var expireTime = localStorage.getItem(key + '__et')
    if (!expireTime) {
      return value
    }
    var curTime = (new Date()).getTime()
    if (curTime > expireTime) {
      this.remove(key)
      return null
    } else {
      return value
    }
  },
  getExpireTime: function (key) {
    return localStorage.getItem(key + '__et')
  },
  remove: function (key) {
    localStorage.removeItem(key)
    localStorage.removeItem(key + '__et')
  }
}

export { localStorageUtils }
